module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"search_by_code":"Найти по номеру детали","enter_code":"Введите номер детали","not_found":"Ничего не найдено.","all_results":"Все результаты"},"en":{"search_by_code":"Search by product code","enter_code":"Enter product code","not_found":"Not found.","all_results":"All results"}}')
  delete Component.options._Ctor
}
